module.exports = __webpack_public_path__ + "static/media/left.48e6d48f.svg";